import unitConverter from '../../utils/unitConverter'

const timeUnitDateFormatMap = {
  Minutes: 'YYYY-MM-DD HH:mm',
  Hours: 'YYYY-MM-DD HH',
  Date: 'YYYY-MM-DD',
  Month: 'YYYY-MM',
  FullYear: 'YYYY'
}

export default class DataFormatter {
  static formatter1 ({dimensions, dataDimensionIdProp, unitProp, timeRange: [beginTime, endTime], dataType: {interval: timeInterval, unit: timeUnit}, dateFormat, dataList, valueProp = 'value'}) {
    beginTime = new Date(beginTime)
    let beginTS = beginTime.getTime()
    const endTS = new Date(endTime).getTime()
    const dataTimes = []
    const dateFormatStr = timeUnitDateFormatMap[timeUnit]

    for (; beginTS <= endTS;) {
      dataTimes.push([beginTS, beginTime.format(dateFormatStr), beginTime.format()])
      beginTime[`set${timeUnit}`](beginTime[`get${timeUnit}`]() + timeInterval)
      beginTS = beginTime.getTime()
    }

    const dimensionMap = dimensions.reduce((map, dimension) => {
      map[dimension.id] = dimension
      return map
    }, {})

    const seriesMap = dataList.reduce((map, data) => {
      const dimensionId = data[dataDimensionIdProp]
      const dimension = dimensionMap[dimensionId]

      if (dimension) {
        const seriesDimensionData = map[dimensionId]
        const dataTime = new Date(data.dataTime).format(dateFormatStr)
        seriesDimensionData[dataTime] = {
          dataTime,
          value: Number(unitConverter(data[valueProp], dimension.stdUnit, dimension[unitProp], dimension.molecular).toFixed(3))
        }
      }

      return map
    }, dimensions.reduce((map, dimension) => {
      map[dimension.id] = {}
      return map
    }, {}))

    const windSpeed = dimensionMap['1012']

    if (windSpeed) {
      const windDir = dimensionMap['1013']

      if (windDir) {
        windSpeed.name += '风向'
        dimensions.splice(dimensions.indexOf(windDir), 1)

        const {seriesParam} = windSpeed
        seriesParam.showSymbol = true
        seriesParam.showAllSymbol = true
        // seriesParam.symbol = `image://data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGcgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTUwLjAwMDAwMCwgLTYwLjAwMDAwMCkiIGZpbGwtcnVsZT0ibm9uemVybyIgZmlsbD0iIzc5NTU0OCI+PHBvbHlnb24gdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTguMDAwMDAwLCA2OC4wMDAwMDApIHNjYWxlKDEsIC0xKSByb3RhdGUoOTAuMDAwMDAwKSB0cmFuc2xhdGUoLTU4LjAwMDAwMCwgLTY4LjAwMDAwMCkgIiBwb2ludHM9IjUwIDczIDU1LjMwNzY5MjMgNjggNTAgNjMgNjYgNjgiPjwvcG9seWdvbj48L2c+PC9nPjwvc3ZnPg==`
        // seriesParam.symbol = `http://localhost:8722/images/arrow.svg`
        // seriesParam.symbol = `${__dirname}/../public/images/arrow.svg`
        seriesParam.symbol = 'arrow'
        seriesParam.symbolSize = 6
        // seriesParam.color = '#795548'
        // console.log(`${__dirname}/../public/images/arrow.svg`)

        const windSpeedDataMap = seriesMap['1012']
        const windDirDataMap = seriesMap['1013']

        Object.entries(windSpeedDataMap).forEach(([dataTime, windSpeedData]) => {
          const windDirData = windDirDataMap[dataTime]

          if (windDirData) {
            windSpeedData.symbolRotate = 180 - windDirData.value
          }
        })
      }
    }

    return {
      id: '',
      name: '',
      beginTS,
      endTS,
      dataTimes,
      dimensions,
      unitProp,
      selectedNames: null,
      dateFormat: dateFormat || dateFormatStr,
      seriesMap
    }
  }

  static formatter2 ({
    dimension,
    unitProp,
    windIds: [
      windSpeedId,
      windDirId
    ],
    valueProp,
    windDataList,
    dataList
  }) {
    const {stdUnit, molecular} = dimension
    const unit = dimension[unitProp]
    const dataMap = dataList.reduce((map, data) => {
      const newData = map[data.dataTime]

      if (newData) {
        newData.value = Number(unitConverter(data[valueProp], stdUnit, unit, molecular).toFixed(3))
      }

      return map
    }, windDataList.reduce((map, data) => {
      const {dataTime} = data
      let windData = map[dataTime]

      if (!windData) {
        windData = map[dataTime] = {}
      }

      windData[data.factorId] = data.value
      return map
    }, {}))

    const dataProps = [windSpeedId, windDirId, 'value']

    return {
      unit,
      dataList: Object.values(dataMap).reduce((list, data) => {
        if (Object.keys(data).length === 3) {
          list.push(dataProps.reduce((item, dataProp) => {
            item.push(data[dataProp])
            return item
          }, []))
        }

        return list
      }, [])
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ReportChart/DataFormatter.js